import { useToast } from '@lifebit-ai/lds'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { bulkUnassignImportRequests } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type { BulkUnassignImportRequestsParams } from 'services/import-requests/types'
import { invalidateRequestActivityQueries } from 'services/request-activity/invalidateRequestActivityQueries'
import type { ApiErrorResponse } from 'services/types'

interface UseBulkUnassignImportRequestsParams {
  onSuccess?: () => void
}

export const useBulkUnassignImportRequests = ({ onSuccess }: UseBulkUnassignImportRequestsParams = {}) => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation<void, ApiErrorResponse, BulkUnassignImportRequestsParams>({
    mutationFn: params => bulkUnassignImportRequests(params),
    onSuccess: () => {
      toast({ message: 'Import requests unassigned successfully' })
      queryClient.invalidateQueries({ queryKey: ImportRequestQueryKeys.All() })
      invalidateRequestActivityQueries(queryClient)
      onSuccess?.()
    },
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to unassign import requests') })
    }
  })
}
